import React from 'react';
import {
  TFunction,
  useTranslation,
  useExperiments,
} from '@wix/yoshi-flow-editor';
import { DurationDataHooks } from './dataHooks';
import { TagName } from '../../../../utils/tagName.const';
import {
  getCourseTotalNumberOfSessionsDurationText,
  getFormattedDuration,
} from '../../../../utils/duration/duration';
import Text, { TextType } from '../../Text/Text';
import { FormNestedSlot } from '../../../../types/formSelectedSlots';
import { ExperimentsConsts } from '../../../../consts/experiments';

export interface DurationProps {
  totalNumberOfSessions: number;
  slot: FormNestedSlot;
}

const Duration: React.FC<DurationProps> = ({ totalNumberOfSessions, slot }) => {
  const { t } = useTranslation();
  const { startDate, endDate } = slot;
  const { experiments } = useExperiments();

  const isShowDurationInDaysEnabled = experiments.enabled(
    ExperimentsConsts.ShowDurationInDays,
  );

  const duration = getDuration({
    totalNumberOfSessions,
    startDate: startDate!,
    endDate: endDate!,
    t,
    isShowDurationInDaysEnabled,
  });

  return (
    <Text
      type={TextType.Secondary}
      data-hook={DurationDataHooks.DURATION}
      tagName={TagName.Paragraph}
      aria-label={duration.durationAriaText}
    >
      {duration.durationText}
    </Text>
  );
};

const getDuration = ({
  totalNumberOfSessions,
  startDate,
  endDate,
  t,
  isShowDurationInDaysEnabled,
}: {
  totalNumberOfSessions: number;
  startDate: string;
  endDate: string;
  t: TFunction;
  isShowDurationInDaysEnabled?: boolean;
}) => {
  return totalNumberOfSessions > 1
    ? getCourseTotalNumberOfSessionsDurationText(totalNumberOfSessions, t)
    : getFormattedDuration({
        startDate,
        endDate,
        t,
        isShowDurationInDaysEnabled,
      });
};
export default Duration;
